import DropzoneArea from './dropzone-area';

export default DropzoneArea;
